<template>
  <div class="row h-row-inputBox">
    <div v-for="(value,index) in list" :key="index">
      <div class="col-sm-6 h-col-inputBox col-nsmf-div col-nsmf-div-t">
        <div class="form-group">
          <div class="e-float-input">
            <div :id="value" style="width: 300px;height: 250px;"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import echarts from "echarts";
export default {
  name: "",
  data() {
    return {
      list: [],
      charts: "",
    };
  },
  methods: {
    initData(param, list) {
      this.list = list;
      const drawData = Array.from(param);
      this.$nextTick(() => {
        for (var index in drawData) {
          this.drawLine(drawData[index][0].split('+')[0],drawData[index][0].split('+')[1],drawData[index][1].y,drawData[index][1].x,"");
        }
      });
    },
    //折线图
    drawLine(id, name, dataList, timeList, company) {
      this.charts = echarts.init(document.getElementById(id));
      this.charts.setOption({
        tooltip: {
          color: "#333",
          trigger: "axis",
        },
        legend: {
          data: [name],
          x: "center",
          y: "bottom"
        },
        grid: {
          left: "3%",
          bottom: "15%",
          containLabel: true
        },
        color: ["#3E9BE6"],
        toolbox: {
          feature: {}
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: timeList
        },
        yAxis: {
          type: "value",
          name: company
        },
        series: [
          {
            name: name,
            type: "line",
            data: dataList
          }
        ]
      });
    }
  }
};
</script>
<style scoped>
.col-nsmf-div-t {
  margin-bottom: 35px;
  margin-left: 145px;
}
</style>